import { render, staticRenderFns } from "./GaugeChart.vue?vue&type=template&id=04234382&scoped=true"
import script from "./GaugeChart.vue?vue&type=script&lang=js"
export * from "./GaugeChart.vue?vue&type=script&lang=js"
import style0 from "./GaugeChart.vue?vue&type=style&index=0&id=04234382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04234382",
  null
  
)

export default component.exports